<template>
  <div class="top-toolbar">

    <div class="toolbar-row">
      <span class="toolbar-item">
        <b>工单:</b>
            <router-link :to="'/order/detail/'+orderDetail.orderid" target="_blank">
              <span>{{orderDetail.title}}/ORD{{orderDetail.orderid}}</span>
            </router-link>
       </span>
      <span class="toolbar-item"
            v-if="orderDetail.marketname">
        <b>{{orderDetail.type * 1 === 23 ? '宴席订单编号:' : '门店:'}}</b>
          <router-link v-if="orderDetail.marketname" :to="{path: '/order/table',query:{marketname:orderDetail.marketname}}" target="_blank">
            {{ orderDetail.marketname | sjfmarketname(orderDetail.type) }}
          </router-link>
      </span>
      <span class="toolbar-item">
        <b>地区:</b>
        <span>{{orderDetail.provincename}}</span>
        <span v-if="orderDetail.cityname">/{{orderDetail.cityname}}</span>
        <span v-if="orderDetail.areaname">/{{orderDetail.areaname}}</span>
      </span>
      <span class="toolbar-item">
        <b>完成用户:</b>
         <router-link v-if="orderDetail.userinfo" :to="{path: '/order/table',query:{userid:orderDetail.userinfo.userid}}" target="_blank">
           <template v-if="showUserInfo()">
             <span v-if="orderDetail.userinfo.realname">{{orderDetail.userinfo.realname}}</span>
             ({{orderDetail.userinfo.userid}})
             <span v-if="orderDetail.userinfo.cellphone"> - {{orderDetail.userinfo.cellphone}}</span>
           </template>
           <template v-else>
             <span>{{orderDetail.userinfo.userid}}</span>
           </template>
         </router-link>
      </span>
      <span class="toolbar-item"
            v-if="orderDetail.marketinfo">
        <b>卖场地址:</b>
        <span>{{orderDetail.marketinfo.address}}</span>
      </span>
      <span class="toolbar-item">
        <b>自动群组目标数标记任务:</b>
        <span>{{Number(orderDetail.addto_taskgroup_target_num) ? '是' : '否'}}</span>
      </span>
      <span class="toolbar-item">
        <b>签到平台:</b>
        <span>{{orderDetail.str_start_app_type}}</span>
      </span>
      <span class="toolbar-item">
        <b>提交平台:</b>
        <span>{{orderDetail.str_finish_app_type}}</span>
      </span>
    </div>

    <div class="toolbar-row">
      <span class="toolbar-item">
        <b>工单状态:</b>
        <span><b style="color:#5b82bd">{{orderDetail.strstatus}}</b></span>
      </span>
      <span class="toolbar-item">
        <b>审核次数:</b>
        <span><b style="color:#5b82bd">{{orderDetail.review}}</b></span>
      </span>
      <span class="toolbar-item"
            v-if="orderDetail.userfinishtime && orderDetail.userstarttime">
        <b>做单时长:</b>
        <span class="el-icon-time"> {{(Date.parse(orderDetail.userfinishtime) - Date.parse(orderDetail.userstarttime))/1000|formatTimer}}</span>
      </span>
      <span class="toolbar-item">
        <b>照片总数:</b>
        <span>{{photoCount}}</span>
      </span>
      <span class="toolbar-item"
            v-if="orderDetail.checkindistance">
        <b>签到距离商城:</b>
        <span v-if="orderDetail.checkindistance >= 1000">
          <b style="color:#F56C6C">{{orderDetail.checkindistance}}米</b>
        </span>
        <span v-else>{{orderDetail.checkindistance}}米</span>
      </span>
      <span class="toolbar-item"
            v-if="orderDetail.finishdistance">
        <b>完成距离商场:</b>
        <span v-if="orderDetail.finishdistance >= 1000">
          <b style="color:#F56C6C">{{orderDetail.finishdistance}}米</b>
        </span>
        <span v-else>{{orderDetail.finishdistance}}米</span>
      </span>
      <span class="toolbar-item"
            v-if="orderDetail.outrange_times">
        <b>出GPS签到范围次数:</b>
        <span>{{orderDetail.outrange_times}}次</span>
      </span>
      <span class="toolbar-item"
            v-if="orderDetail.interrupted_times">
        <b>重新签到次数:</b>
        <span>{{orderDetail.interrupted_times}}次</span>
      </span>
      <span class="toolbar-item"
            v-if="orderDetail.salary">
        <b>赏金:</b>
        <span>{{salaryValue(orderDetail.salary)}}元</span>
      </span>
    </div>

    <div class="toolbar-row">
      <span class="toolbar-item">
        <b>完成日期:</b>
        <span class="el-icon-date"> {{orderDetail.userfinishtime}}</span>
      </span>
      <span class="toolbar-item">
        <b>更新日期:</b>
        <span class="el-icon-date"> {{orderDetail.lastupdatetimeadmin}}</span>
      </span>
    </div>

    <div class="toolbar-row">
      <span class="toolbar-item">
        <b>任务结束时间:</b>
        <span class="el-icon-date"> {{orderDetail.taskendtime}}</span>
      </span>
      <span class="toolbar-item">
        <b>用户最晚完成时间:</b>
        <span class="el-icon-date"> {{orderDetail.endtime}}</span>
      </span>
    </div>

    <div class="toolbar-row"
         v-if="orderDetail.errormessage">
      <span class="toolbar-item">
        <b>退回理由:</b>
        <span>{{orderDetail.errormessage}}</span>
      </span>
    </div>

    <div class="toolbar-row"
         v-if="orderDetail.review_message">
      <span class="toolbar-item">
        <b>复审通过理由:</b>
        <span>{{orderDetail.review_message}}</span>
      </span>
    </div>

    <div class="toolbar-row"
         v-if="asrCheckSummaryVisible">
      <span class="toolbar-item asr-check-summary">
        <b>录音风险检查:</b>
        <template v-if="asrCheckFailed">
          <el-tag size="mini" type="info">检查失败</el-tag>
          <span v-if="asrCheckResult.fail_reason" class="asr-check-fail-reason">{{asrCheckResult.fail_reason}}</span>
        </template>
        <template v-else-if="asrCheckRunning">
          <el-tag size="mini" type="info">检查中</el-tag>
        </template>
        <template v-else-if="asrCheckHasRisk">
          <el-tag
            v-for="item in asrRiskItems"
            :key="'asr-risk-' + item.id"
            size="mini"
            type="danger"
            class="asr-risk-tag"
            @click.native="onRiskTagClick(item)">
            {{item.alias}}
          </el-tag>
        </template>
        <template v-else-if="asrCheckSuccess">
          <el-tag size="mini" type="success">未触发风险</el-tag>
        </template>
      </span>
    </div>

  </div>
</template>

<script>
export default {
  mixins: [],
  data () {
    return {
      adminHost: window._env_.VUE_APP_OLD_ADMIN_HOST,
    }
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
      photoCount: state => state.orderReview.photoCount,
      asrCheckResult: state => state.orderReview.asrCheckResult,
    }),
    asrCheckSummaryVisible () {
      return !!this.asrCheckResult
    },
    asrCheckFailed () {
      const status = this.asrCheckResult && Number(this.asrCheckResult.status)
      return status === 3 || status === 7
    },
    asrCheckRunning () {
      const status = this.asrCheckResult && Number(this.asrCheckResult.status)
      return status === 1 || status === 2 || status === 4 || status === 5
    },
    asrCheckSuccess () {
      return this.asrCheckResult && Number(this.asrCheckResult.status) === 6
    },
    asrCheckHasRisk () {
      return this.asrCheckSuccess && Number(this.asrCheckResult.trigger_risk_status) === 1
    },
    asrRiskItems () {
      if (!this.asrCheckHasRisk || !Array.isArray(this.asrCheckResult.items)) {
        return []
      }
      return this.asrCheckResult.items.filter(item => Number(item.is_trigger_risk) === 1)
    },
  },
  watch: {},
  beforeCreate () {

  },
  created () {
    this.$nextTick(() => {

    })
  },
  mounted () {},
  methods: {
    ...Vuex.mapActions([]),
    onRiskTagClick (item) {
      const segments = Array.isArray(item.asr_segments) ? item.asr_segments : []
      const seg = segments[0]
      if (!seg) {
        this.$message.info('该风险项无命中片段')
        return
      }
      this.$store.commit('orderReview/SET_ASR_CHECK_SEEK', {
        recordUrl: seg.record_url || '',
        beginMs: Number(seg.begin_ms) || 0,
        alias: item.alias || '',
      })
      this.$message.info(`请打开对应录音，将跳转到「${item.alias || '风险点'}」`)
    },
    salaryValue (value) {
      return filter.hasPermission(250) ? value : '*'
    },
    showUserInfo () {
      return filter.hasPermission([251])
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.top-toolbar {
  color: #606266;

  .toolbar-row {
    line-height: 30px;

    .toolbar-item {
      margin-right: 15px;

      & > b {
        margin-right: 5px;
      }
    }
  }

  .asr-check-summary {
    .asr-risk-tag {
      margin-right: 6px;
      cursor: pointer;
    }

    .asr-check-fail-reason {
      margin-left: 8px;
      color: #909399;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReviewInfoPanel/detail.vue